import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import RenderLoader from "./components/RenderLoader";
import Privacy from "./screens/Privacy";
import PackageScreen from "./screens/PackageScreen";
import AirbnbGroceryStockingPage from "./screens/seo/AirbnbGroceryStockingPage";
import LocationCityPage from "./screens/seo/LocationCityPage";
import LocationsHubPage from "./screens/seo/LocationsHubPage";
import SeoPlaceholderPage from "./screens/seo/SeoPlaceholderPage";
import VacationRentalGroceryDeliveryPage from "./screens/seo/VacationRentalGroceryDeliveryPage";
import PreArrivalGroceriesPage from "./screens/seo/PreArrivalGroceriesPage";
import HowItWorksPage from "./screens/seo/HowItWorksPage";
import PricingPage from "./screens/seo/PricingPage";
import ForPropertyManagersPage from "./screens/seo/ForPropertyManagersPage";
import ForEnterprisePropertyManagersPage from "./screens/seo/ForEnterprisePropertyManagersPage";
import ForMidMarketPropertyManagersPage from "./screens/seo/ForMidMarketPropertyManagersPage";
import AirbnbGroceryDeliveryPage from "./screens/seo/AirbnbGroceryDeliveryPage";
import IntegrationsPage from "./screens/seo/IntegrationsPage";
import StreamlineIntegrationPage from "./screens/seo/StreamlineIntegrationPage";
import HospitableIntegrationPage from "./screens/seo/HospitableIntegrationPage";
import { cityPages, placeholderRoutes } from "./data/seoPages";

const CheckoutScreen = lazy(() => import("./screens/CheckoutScreen"));
const GuestHomeScreen = lazy(() => import("./screens/GuestHomeScreen"));
const ProductScreen = lazy(() => import("./screens/ProductScreen"));
const CartScreen = lazy(() => import("./screens/CartScreen"));
const OrderCompleted = lazy(() => import("./screens/OrderCompleted"));
const LandingPage = lazy(() => import("./screens/LandingPage"));
const Guest = lazy(() => import("./screens/Guest"));
const OrderDriverImages = lazy(() => import("./components/OrderDriverImages"));
const PageNotFoundScreen = lazy(() => import("./screens/PageNotFoundScreen"));
const GuestAddOn = lazy(() => import("./screens/GuestAddOn.js"));
const SavedCartGuest = lazy(() => import("./screens/SavedCartGuest"));
const SMSCompliance = lazy(() => import("./screens/SMSCompliance"));
const OrderTracking = lazy(() => import("./screens/OrderTracking"));
const TermsAndConditions = lazy(() => import("./screens/TermsAndConditions"));
const ContactScreen = lazy(() => import("./screens/ContactScreen"));


function App() {
  return (
    <div className="overflow-x-hidden">
      <div className="w-full min-h-screen overflow-x-hidden">
        <Routes>
          {/* <Route exact path='/'> <Navigate to="/guest" /> </Route> */}
          <Route path="/" element={<Suspense fallback={<RenderLoader />}><LandingPage /></Suspense>} />
          <Route path="/homeproducts" element={<Suspense fallback={<RenderLoader />}><GuestHomeScreen /></Suspense>} />
          <Route path="/guest/:pid" element={<Suspense fallback={<RenderLoader />}><Guest /></Suspense>} />
          <Route path="/product/:id" element={<Suspense fallback={<RenderLoader />}><ProductScreen /></Suspense>} />
          <Route path="/cart" element={<Suspense fallback={<RenderLoader />}><CartScreen /></Suspense>} />
          <Route path="/checkout" element={<Suspense fallback={<RenderLoader />}><CheckoutScreen /></Suspense>} />
          <Route path="/orderCompleted" element={<Suspense fallback={<RenderLoader />}><OrderCompleted /></Suspense>} />
          <Route path="/privacy" element={<Suspense fallback={<RenderLoader />}><Privacy /></Suspense>} />
          <Route path="/package/:pid" element={<Suspense fallback={<RenderLoader />}><PackageScreen /></Suspense>} />
          <Route path="/guest" element={<Suspense fallback={<RenderLoader />}><Guest /></Suspense>} />
          <Route path="/guest/:pid/ebikes" element={<Suspense fallback={<RenderLoader />}><Guest /></Suspense>} />
          <Route path="/order/:oid" element={<Suspense fallback={<RenderLoader />}><OrderDriverImages /></Suspense>} />
          <Route path="/sms" element={<Suspense fallback={<RenderLoader />}><SMSCompliance /></Suspense>} />
          <Route path="/terms" element={<Suspense fallback={<RenderLoader />}><TermsAndConditions /></Suspense>} />
          <Route path="/contact" element={<Suspense fallback={<RenderLoader />}><ContactScreen /></Suspense>} />
          <Route path="/order-tracking/:oid" element={<Suspense fallback={<RenderLoader />}><OrderTracking /></Suspense>} />
          <Route path="/guest/:pid/savedcart/:cartCode" element={<Suspense fallback={<RenderLoader />}><SavedCartGuest /></Suspense>} />

          <Route path="/airbnb-grocery-stocking" element={<AirbnbGroceryStockingPage />} />
          <Route path="/vacation-rental-grocery-delivery" element={<VacationRentalGroceryDeliveryPage />} />
          <Route path="/pre-arrival-groceries" element={<PreArrivalGroceriesPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/for/property-managers" element={<ForPropertyManagersPage />} />
          <Route path="/for/enterprise-property-managers" element={<ForEnterprisePropertyManagersPage />} />
          <Route path="/for/mid-market-property-managers" element={<ForMidMarketPropertyManagersPage />} />
          <Route path="/airbnb-grocery-delivery" element={<AirbnbGroceryDeliveryPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/integrations/streamline" element={<StreamlineIntegrationPage />} />
          <Route path="/integrations/hospitable" element={<HospitableIntegrationPage />} />
          <Route path="/locations" element={<LocationsHubPage />} />
          {placeholderRoutes.map((path) => (
            <Route key={path} path={path} element={<SeoPlaceholderPage path={path} />} />
          ))}
          {cityPages.map((cityItem) => (
            <Route
              key={cityItem.city}
              path={`/locations/${cityItem.city}/airbnb-grocery-delivery`}
              element={<LocationCityPage cityConfig={cityItem} />}
            />
          ))}
          {/* <Route path="/support" element={<SupportScreen />} /> */}
          <Route path="/guest/:pid/addon/:orderAddOnCode" element={<Suspense fallback={<RenderLoader />}><GuestAddOn /></Suspense>} />
          <Route path="*" element={<PageNotFoundScreen />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
